import { type Theme } from '../theme';
import { type CSSObject } from '@emotion/react';

export type FontWeight = 'regular' | 'medium' | 'semi-bold';

type Props = {
  theme: Theme;
  fontWeight?: FontWeight;
};

export const getFontWeight = ({ theme, fontWeight }: Props): number => {
  switch (fontWeight) {
    case 'regular': {
      return theme.typography.fontWeightRegular;
    }
    case 'medium': {
      return theme.typography.fontWeightMedium;
    }
    case 'semi-bold': {
      return theme.typography.fontWeightSemiBold;
    }
    default: {
      return theme.typography.fontWeightRegular;
    }
  }
};

export const getVisuallyHiddenStyles = (): CSSObject => {
  return {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    width: '1px',
  };
};
